/* cs-minicart.js — Citadel bottom-sheet mini cart.
   Paul picked the bottom sheet 2026-08-02 and asked it fire on EVERY add to cart on the site.

   Why interception rather than a click handler: the store adds to cart through several
   paths (the cabinet colourway script POSTs /cart/add.js directly, ordinary product forms
   POST /cart/add, theme components use fetch or XHR). A click handler would have to know
   all of them and would miss the next one.

   WHY WE READ THE ADD RESPONSE (Paul test 2, 2026-08-02): the first build matched the added
   line by guessing a variant id from the request body, then fell back to the LAST item in
   the cart. Shopify orders cart lines by first-added, not most-recent, so every subsequent
   add showed the first product again. /cart/add.js returns exactly what it added, so we use
   that and only fall back to the cart when there is no readable response.

   The cart PAGE is untouched: the cart icon still goes to /cart.
*/
(function () {
  if (window.__csMiniCart) return;
  window.__csMiniCart = true;

  var ADD = /\/cart\/add(\.js)?(\?|$)/;
  var _fetch = window.fetch ? window.fetch.bind(window) : null;

  function money(c) {
    return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  var css = ''
    + '.csmc-veil{position:fixed;inset:0;background:rgba(27,29,31,.34);opacity:0;pointer-events:none;'
    + 'transition:opacity .3s cubic-bezier(.4,0,.2,1);z-index:99998}'
    + '.csmc-veil.on{opacity:1;pointer-events:auto}'
    + '.csmc{position:fixed;left:0;right:0;bottom:0;background:#fff;border-top:2px solid #B08D57;'
    + 'padding:16px 16px calc(18px + env(safe-area-inset-bottom,0px));transform:translateY(102%);'
    + 'transition:transform .38s cubic-bezier(.4,0,.2,1);z-index:99999;'
    + 'font-family:var(--cs-sans,"Montserrat",sans-serif);color:#1E2022;'
    + 'box-shadow:0 -18px 40px -22px rgba(27,29,31,.5);max-height:82vh;overflow:auto}'
    + '.csmc.on{transform:translateY(0)}'
    + '@media(min-width:900px){.csmc{left:auto;right:22px;bottom:22px;width:390px;'
    + 'border:1px solid rgba(38,41,43,.18);border-top:2px solid #B08D57;'
    + 'transform:translateY(calc(100% + 30px))}.csmc.on{transform:translateY(0)}}'
    + '.csmc-grip{width:36px;height:3px;background:rgba(38,41,43,.18);border-radius:2px;margin:0 auto 12px}'
    + '@media(min-width:900px){.csmc-grip{display:none}}'
    + '.csmc-eye{font-size:9.5px;font-weight:500;letter-spacing:.18em;text-transform:uppercase;color:#9A7A45}'
    + '.csmc-row{display:flex;gap:11px;align-items:flex-start;margin-top:11px}'
    + '.csmc-th{width:52px;height:52px;flex:none;background:#F4EEE3;'
    + 'border:1px solid rgba(38,41,43,.10);object-fit:contain;display:block}'
    + '.csmc-nm{font-size:13px;line-height:1.35}'
    + '.csmc-mt{font-size:11px;color:#85888C;margin-top:3px}'
    + '.csmc-pr{margin-left:auto;white-space:nowrap;'
    + 'font-family:var(--cs-serif,"Cormorant Garamond",Georgia,serif);font-size:15px;font-weight:300}'
    + '.csmc-sub{display:flex;justify-content:space-between;align-items:baseline;'
    + 'border-top:1px solid rgba(38,41,43,.10);padding-top:11px;margin-top:12px;font-size:12px;color:#5B5E62}'
    + '.csmc-sub b{font-family:var(--cs-serif,"Cormorant Garamond",Georgia,serif);'
    + 'font-size:18px;font-weight:300;color:#1E2022}'
    + '.csmc-btns{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:12px}'
    /* A button and an anchor do not share a baseline, so padding alone left the label
       sitting low in the box on desktop. Flex centring with a fixed height makes both
       identical. Paul, 2026-08-02. */
    + '.csmc-b{display:flex;align-items:center;justify-content:center;min-height:44px;'
    + 'padding:0 10px;font-size:9.5px;font-weight:500;letter-spacing:.14em;line-height:1;'
    + 'text-transform:uppercase;text-align:center;cursor:pointer;border:1px solid #1E2022;'
    + 'background:transparent;color:#1E2022;text-decoration:none;font-family:inherit;'
    + '-webkit-appearance:none;appearance:none;box-sizing:border-box}'
    + '.csmc-b.solid{background:#1B1D1F;color:#fff}'
    + '@media (prefers-reduced-motion:reduce){.csmc,.csmc-veil{transition:none}}';

  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var veil = document.createElement('div');
  veil.className = 'csmc-veil';
  var sheet = document.createElement('div');
  sheet.className = 'csmc';
  sheet.setAttribute('role', 'dialog');
  sheet.setAttribute('aria-label', 'Added to cart');
  sheet.innerHTML =
    '<div class="csmc-grip"></div>'
    + '<div class="csmc-eye">Added to cart</div>'
    + '<div class="csmc-row"><img class="csmc-th" alt="" hidden>'
    + '<div><div class="csmc-nm"></div><div class="csmc-mt"></div></div>'
    + '<div class="csmc-pr"></div></div>'
    + '<div class="csmc-sub"><span>Subtotal</span><b></b></div>'
    + '<div class="csmc-btns"><button type="button" class="csmc-b" data-csmc-close>Keep shopping</button>'
    + '<a class="csmc-b solid" href="/cart">View cart</a></div>';

  function mount() {
    if (!document.body || sheet.parentNode) return;
    document.body.appendChild(veil);
    document.body.appendChild(sheet);
  }
  if (document.body) mount(); else document.addEventListener('DOMContentLoaded', mount);

  var timer;
  function close() {
    sheet.classList.remove('on');
    veil.classList.remove('on');
    clearTimeout(timer);
  }
  veil.addEventListener('click', close);
  sheet.addEventListener('click', function (e) {
    if (e.target.closest('[data-csmc-close]')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  function paint(item, totalCents) {
    /* Desktop (>=901px) uses the header dropdown mini-cart only; the sheet is the
       MOBILE surface. Paul 2026-08-10: two drawers were opening on desktop adds. */
    if (window.matchMedia && window.matchMedia("(min-width:901px)").matches) return;
    mount();
    var img = sheet.querySelector('.csmc-th');
    var src = item.image || item.featured_image || null;
    if (src && typeof src === 'object') src = src.url || null;
    if (src) { img.src = String(src).replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2'); img.hidden = false; }
    else { img.hidden = true; }
    sheet.querySelector('.csmc-nm').textContent = item.product_title || item.title || 'Added to cart';
    var meta = [];
    if (item.sku) meta.push(item.sku);
    /* /cart/add.js returns the CUMULATIVE line quantity, not the amount just added, so
       adding 3 to a line of 3 reports 6. Label it as the cart total to avoid reading
       as a miscount. Paul test run, 2026-08-02. */
    if (item.quantity) meta.push(item.quantity + ' in cart');
    sheet.querySelector('.csmc-mt').textContent = meta.join(' · ');
    var line = item.final_line_price != null ? item.final_line_price : item.line_price;
    sheet.querySelector('.csmc-pr').textContent = line != null ? money(line) : '';
    sheet.querySelector('.csmc-sub b').textContent = totalCents != null ? money(totalCents) : '';
    sheet.classList.add('on');
    veil.classList.add('on');
    clearTimeout(timer);
    timer = setTimeout(close, 6500);
  }

  /* The item is known from the add response; only the subtotal needs the cart. */
  function showAdded(added) {
    if (!_fetch) return;
    _fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        paint(added, cart.total_price);
        document.dispatchEvent(new CustomEvent('cs:cart:updated', { detail: cart }));
      })
      .catch(function () { paint(added, null); });
  }

  /* Fallback only, when the add response cannot be read. */
  function showFromCart() {
    if (!_fetch) return;
    _fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        paint(cart.items[cart.items.length - 1], cart.total_price);
      })
      .catch(function () { });
  }

  function fromAddResponse(data) {
    if (!data) return null;
    if (data.items && data.items.length) return data.items[data.items.length - 1];
    if (data.id || data.variant_id || data.product_title) return data;
    return null;
  }

  function handle(data) {
    var added = fromAddResponse(data);
    if (added) showAdded(added); else showFromCart();
  }

  /* 1. fetch */
  if (window.fetch) {
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var isAdd = ADD.test(url) && method === 'POST';
      return orig.apply(this, arguments).then(function (res) {
        if (isAdd && res && res.ok) {
          res.clone().json().then(handle).catch(function () { showFromCart(); });
        }
        return res;
      });
    };
  }

  /* 2. XMLHttpRequest */
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) {
    this.__csAdd = ADD.test(u || '') && String(m || '').toUpperCase() === 'POST';
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    if (self.__csAdd) {
      self.addEventListener('load', function () {
        if (self.status < 200 || self.status >= 300) return;
        var data = null;
        try { data = JSON.parse(self.responseText); } catch (e) { }
        handle(data);
      });
    }
    return _send.apply(this, arguments);
  };

  /* 3. ordinary product forms doing a full-page POST */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || !ADD.test(form.action)) return;
    if (e.defaultPrevented || !_fetch) return;
    e.preventDefault();
    var fd = new FormData(form);
    _fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(handle)
      .catch(function () { form.submit(); });
  }, true);
})();
